/**
 * American Fusion Wheels — Tire Fitment Calculator (Floating Popup)
 * Wheel diameter + width → all compatible tire sizes
 */
(function () {
  'use strict';

  // [min, standard max, aggressive max] — aggressive covers truck/off-road fitments
  var WIDTH_MAP = {
    '5.0':[155,195,205],'5.5':[165,205,215],'6.0':[175,215,235],'6.5':[185,225,245],
    '7.0':[195,235,255],'7.5':[205,245,265],'8.0':[215,255,285],'8.5':[225,265,295],
    '9.0':[235,275,325],'9.5':[245,285,335],'10.0':[255,295,345],'10.5':[265,305,355],
    '11.0':[275,315,365],'11.5':[285,325,375],'12.0':[295,335,375],'12.5':[305,345,375],
    '13.0':[315,355,375],'14.0':[335,375,385]
  };

  var TIRE_WIDTHS = [155,165,175,185,195,205,215,225,235,245,255,265,275,285,295,305,315,325,335,345,355,365,375,385];
  var ASPECT_RATIOS = [25,30,35,40,45,50,55,60,65,70,75];
  var DIAMETERS = [], WIDTHS = [];
  for (var d = 14; d <= 30; d++) DIAMETERS.push(d);
  for (var w = 5.0; w <= 14.0; w += 0.5) WIDTHS.push(w.toFixed(1));

  function getIdealRange(min, max) {
    var s = max - min;
    return [min + Math.round(s * 0.2), max - Math.round(s * 0.2)];
  }

  function calculate(dia, width) {
    var r = WIDTH_MAP[width];
    if (!r) return [];
    var stdMin = r[0], stdMax = r[1], aggMax = r[2];
    var ideal = getIdealRange(stdMin, stdMax);
    var out = [];
    // Include all tires from min up to aggressive max
    var compat = TIRE_WIDTHS.filter(function(t){return t>=stdMin&&t<=aggMax;});

    compat.forEach(function(tw) {
      var fit; // 'ideal', 'ok', or 'aggressive'
      if (tw >= ideal[0] && tw <= ideal[1]) fit = 'ideal';
      else if (tw >= stdMin && tw <= stdMax) fit = 'ok';
      else fit = 'aggressive';

      ASPECT_RATIOS.forEach(function(ar) {
        var sw = tw * (ar / 100);
        var swIn = sw / 25.4;
        var od = dia + 2 * swIn;
        if (od < dia + 1 || od > dia + 20) return;
        if (ar <= 25 && tw < 205) return;
        out.push({
          size: tw+'/'+ar+'R'+dia, tireWidth: tw, aspect: ar,
          sidewallMM: Math.round(sw*10)/10, sidewallIn: Math.round(swIn*100)/100,
          overallDia: Math.round(od*100)/100, circumference: Math.round(od*Math.PI*100)/100,
          revsPerMile: Math.round(63360/(od*Math.PI)), fit: fit
        });
      });
    });

    out.sort(function(a,b) {
      var order = {ideal:0, ok:1, aggressive:2};
      if (order[a.fit] !== order[b.fit]) return order[a.fit] - order[b.fit];
      return a.overallDia - b.overallDia;
    });
    return out;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function renderResults(results, dia, width, offset) {
    var wrap = document.getElementById('afw-tf-results');
    if (!wrap) return;

    var counts = {ideal:0, ok:0, aggressive:0};
    results.forEach(function(r){ counts[r.fit]++; });
    var tc = results.length;

    var h = '<div class="afw-tf-popup__summary">' +
      '<strong>' + dia + '" &times; ' + width + '"</strong>' +
      (offset ? ' &bull; Offset ' + esc(offset) + 'mm' : '') +
      ' &mdash; <span class="afw-tf-popup__ideal-count">' + counts.ideal + ' ideal</span>, ' +
      counts.ok + ' standard, ' +
      '<span class="afw-tf-popup__agg-count">' + counts.aggressive + ' aggressive</span></div>';

    h += '<div class="afw-tf-popup__filters">' +
      '<button class="afw-tf-popup__ftab afw-tf-popup__ftab--on" data-f="all">All (' + tc + ')</button>' +
      '<button class="afw-tf-popup__ftab" data-f="ideal">Ideal</button>' +
      '<button class="afw-tf-popup__ftab" data-f="aggressive">Aggressive</button></div>';

    h += '<div class="afw-tf-popup__table-wrap"><table class="afw-tf-popup__table">' +
      '<thead><tr><th>Tire Size</th><th>Overall Dia.</th><th>Sidewall</th><th>Fit</th></tr></thead><tbody>';

    var BADGE = {
      ideal:     ['afw-tf-popup__badge--ideal','Ideal'],
      ok:        ['afw-tf-popup__badge--ok','Standard'],
      aggressive:['afw-tf-popup__badge--agg','Aggressive']
    };

    results.forEach(function(r) {
      var b = BADGE[r.fit];
      var rc = r.fit === 'ideal' ? ' afw-tf-popup__tr--ideal' : (r.fit === 'aggressive' ? ' afw-tf-popup__tr--agg' : '');
      h += '<tr class="afw-tf-popup__tr' + rc + '" data-fit="' + r.fit + '">' +
        '<td><strong>' + r.size + '</strong></td>' +
        '<td>' + r.overallDia.toFixed(1) + '"</td>' +
        '<td>' + r.sidewallIn.toFixed(2) + '"</td>' +
        '<td><span class="afw-tf-popup__badge ' + b[0] + '">' + b[1] + '</span></td></tr>';
    });

    h += '</tbody></table></div>';
    wrap.innerHTML = h;
    wrap.style.display = 'block';

    var btns = wrap.querySelectorAll('.afw-tf-popup__ftab');
    [].forEach.call(btns, function(btn) {
      btn.addEventListener('click', function() {
        [].forEach.call(btns, function(b){b.classList.remove('afw-tf-popup__ftab--on');});
        btn.classList.add('afw-tf-popup__ftab--on');
        var f = btn.getAttribute('data-f');
        var rows = wrap.querySelectorAll('.afw-tf-popup__tr');
        [].forEach.call(rows, function(row) {
          row.style.display = (f==='all'||row.getAttribute('data-fit')===f) ? '' : 'none';
        });
      });
    });
  }

  function init() {
    var fab = document.getElementById('afw-tf-fab');
    var overlay = document.getElementById('afw-tf-overlay');
    var closeBtn = document.getElementById('afw-tf-close');
    if (!fab || !overlay) return;

    var diaEl = document.getElementById('afw-tf-diameter');
    var widEl = document.getElementById('afw-tf-width');
    var offEl = document.getElementById('afw-tf-offset');
    var calcBtn = document.getElementById('afw-tf-calc');
    var resultsEl = document.getElementById('afw-tf-results');
    var emptyEl = document.getElementById('afw-tf-empty');
    var noteEl = document.getElementById('afw-tf-offset-note');

    // Populate dropdowns
    DIAMETERS.forEach(function(d) {
      var o = document.createElement('option');
      o.value = d; o.textContent = d + '"';
      diaEl.appendChild(o);
    });
    WIDTHS.forEach(function(w) {
      var o = document.createElement('option');
      o.value = w; o.textContent = w + '"';
      widEl.appendChild(o);
    });

    function checkReady() {
      calcBtn.disabled = !(diaEl.value && widEl.value);
    }
    diaEl.addEventListener('change', checkReady);
    widEl.addEventListener('change', checkReady);

    // Open popup
    fab.addEventListener('click', function() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      setTimeout(function(){ overlay.classList.add('afw-tf-overlay--open'); }, 10);
    });

    // Close popup
    function closePopup() {
      overlay.classList.remove('afw-tf-overlay--open');
      setTimeout(function(){
        overlay.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') closePopup();
    });

    // Calculate
    calcBtn.addEventListener('click', function() {
      var dia = parseInt(diaEl.value, 10);
      var wid = widEl.value;
      if (!dia || !wid) return;

      var offset = offEl ? offEl.value.trim() : '';
      var results = calculate(dia, wid);

      if (offset && noteEl) {
        noteEl.innerHTML = '<i class="las la-info-circle"></i> Offset <strong>' + esc(offset) + 'mm</strong> &mdash; affects fender clearance, not tire-to-wheel fit.';
        noteEl.style.display = 'flex';
      } else if (noteEl) {
        noteEl.style.display = 'none';
      }

      if (results.length === 0) {
        resultsEl.style.display = 'none';
        emptyEl.style.display = 'flex';
        return;
      }

      emptyEl.style.display = 'none';
      renderResults(results, dia, wid, offset);
    });

    if (offEl) {
      offEl.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); if (!calcBtn.disabled) calcBtn.click(); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
